// extracted by mini-css-extract-plugin
export default {"list_inner":"JobDescriptionList_list_inner__Z6zAq","spin":"JobDescriptionList_spin__dhY4g","fadeInDown":"JobDescriptionList_fadeInDown__nuQ94"};